import { createFileRoute } from "@tanstack/react-router";
import { ConsentScreen } from "../../screens/staff/ConsentScreen.tsx";

/**
 * `/staff-access`: where a company's administrators answer a request from Adea's staff to read their run logs (the
 * mail to them links here with `?request=<id>`).
 */
export const Route = createFileRoute("/_app/staff-access")({
  validateSearch: (search: Record<string, unknown>): { request?: string } =>
    typeof search.request === "string" && search.request.length < 64 ? { request: search.request } : {},
  component: ConsentScreen,
});
